module.exports = __webpack_public_path__ + "img/Number=52.d905c15e.png";